import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import {
  usePermissionStatus,
  type PermissionFlag,
} from '@/hooks/usePermission'

interface PermissionRouteProps {
  flag: PermissionFlag
  children: ReactNode
}

export function PermissionRoute({ flag, children }: PermissionRouteProps) {
  const { hasPermission, isLoading } = usePermissionStatus(flag)

  if (isLoading) {
    return (
      <div
        data-testid="permission-loading"
        aria-busy="true"
        aria-live="polite"
        className="flex min-h-64 items-center justify-center text-sm text-muted-foreground"
      >
        Carregando…
      </div>
    )
  }

  if (!hasPermission) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
